import { Types } from '~/graphql';

const regexExp =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;

const isUUID = (input: string | null | undefined): input is Types.UUID =>
    !!input && regexExp.test(input);

export default isUUID;
